import { render, staticRenderFns } from "./UdoModal.vue?vue&type=template&id=601300e8&scoped=true"
import script from "./UdoModal.vue?vue&type=script&lang=js"
export * from "./UdoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601300e8",
  null
  
)

export default component.exports